// @flow
import { ContactosActionTypes } from './constants';

type ContactosAction = { type: string, payload: {} | string };

// common success
export const contactosApiResponseSuccess = (actionType: string, data: any): ContactosAction => ({
    type: ContactosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const contactosApiResponseError = (actionType: string, error: string): ContactosAction => ({
    type: ContactosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getContacto = (contactoId: string): ContactosAction => ({
    type: ContactosActionTypes.GET_CONTACTO,
    payload: { contactoId },
});
export const updateContacto = (contacto:any):ClientsAction=>({
    type:ContactosActionTypes.UPDATE_CONTACTO,
    payload:contacto
})
export const listContactos = (): ContactosAction => ({
    type: ContactosActionTypes.LIST_CONTACTOS,
    payload: {},
});

export const resetContactos = (): ContactosAction => ({
    type: ContactosActionTypes.RESET,
    // type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

